module.exports = __webpack_public_path__ + "static/img/1.b4d2471.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/dishini/1.jpg
// module id = BVmP
// module chunks = 1